import {useMemo} from 'react';
import merge from 'themes/utils/merge';

export default function (theme, style) {
    return useMemo(() => merge(theme, style), [theme, style]);
}
